export default __webpack_public_path__ + "fdd7dde2ce292edf61c63e71bd8785a2.svg";